module.exports = __webpack_public_path__ + "static/11-thumb-b2d21dd67a065a4f32d7d7bd9e4c488b.jpg";